import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { DepartamentoService } from 'src/app/services/departamento-service'
import { StatusInscricao } from 'src/app/models/status-inscricao'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { UnespCoreUserService } from '@unesp/core'
import { DataService } from 'src/app/services/data-service'

@Component({
  selector: 'app-departamento-status-inscritos',
  templateUrl: './departamento-status-inscritos.component.html',
  styleUrls: ['./departamento-status-inscritos.component.css'],
  standalone: false
})
export class DepartamentoStatusInscritosComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = ['detalhes', 'resumo']
  dataSource: MatTableDataSource<StatusInscricao> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  idDepartamentoSecao: number = 0
  idUnidade: number = 0

  constructor(
    private departamentoService: DepartamentoService,
    private unespCoreUserService: UnespCoreUserService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
    this.unespCoreUserService.user$.subscribe(user => {
      this.idDepartamentoSecao = (user as UsuarioLogin).idLotacaoOficial ?? 0
      this.idUnidade = (user as UsuarioLogin).idUnidadeUniversitaria ?? 0
      this.getData()
    })
  }

  getData(): void {
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    this.departamentoService
      .statusInscricao(this.idDepartamentoSecao, this.idUnidade, this.anoSelecionado)
      .subscribe(data => {
        this.dataSource = new MatTableDataSource(data)
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
      })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  scrollTo(element: any): void {
    ;(document.getElementById(element) as HTMLElement).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }

  exportar() {
    let content = `"ID","Discente","CPF","Câmpus","Programa","Disciplina","Período","1- Inscrição","2- Carga horária prevista lançada","3- Upload plano de atividades assinado pelo docente","4- Plano de atividades com carga horária prevista","5- Vínculo no sistema da graduação (SISGRAD)","6- Plano de atividades com carga horária efetivada","7- Relatório entregue pelo discente","8- Relatório aprovado pelo docente responsável","9- Relatório homologado pelo chefe do departamento"\r\n`
    this.dataSource.data.forEach(row => {
      content += `"${row.id}","${row.nome}","${row.cpf.toString()}","${row.campus}","${row.programa}","${
        row.disciplina
      } - ${row.codigo}","${row.ano} ${row.semestre}","${row.aprovado}","${row.cargaHorariaPrevistaLancada}","${
        row.planoEntregue
      }","${row.planoAprovado}","${row.vinculoAcademico}","${row.cargaHorarioEfetivaLancada}","${
        row.relatorioEntregue
      }","${row.relatorioAprovadoDocenteResponsavel}","${row.relatorioHomologadoChefeDepartamento}"\r\n`
    })
    let binaryData = []
    binaryData.push(content)
    let downloadLink = document.createElement('a')
    downloadLink.setAttribute('download', `inscricoes-${this.anoSelecionado}.csv`)
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'attachment/csv;charset=utf-8;' }))
    document.body.appendChild(downloadLink)
    downloadLink.click()
    downloadLink.remove()
  }
}
